import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//service
import { setAdminPlusRankingPoints } from "../../../../utils/service/ranking";

function PeoplesStaffing(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  useEffect(() => {
    document.getElementById("title-peoples").focus();
  }, []);
  return (
    <section className="section-peoples">
      <a id="title-peoples" className="title-home" tabIndex={12}>
        Página Expo Área - People & Staffing
      </a>
      <div className="div-cards-peoples">
        <div className="card-peoples">
          <a
            className="title-card-peoples"
            id="title-card-peoples"
            tabIndex={13}
          >
            Digital Lovers Festival Benefícios
          </a>
          <video
            tabIndex={14}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("PEOPLEESTAFFINGVIDEOBENEFICIOS")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_people/DIGITAL%20LOVERS%20FESTIVAL%20BENEF%C3%8DCIOS.mp4" />
          </video>
        </div>

        <div className="card-peoples">
          <a className="title-card-peoples" tabIndex={15}>
            Recruiting
          </a>
          <video
            tabIndex={16}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("PEOPLEESTAFFINGVIDEORECRUITING")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_people/Recruiting%20%281%29.mp4" />
          </video>
        </div>

        <div className="card-peoples">
          <a className="title-card-peoples" tabIndex={17}>
            Universidade Corporativa
          </a>
          <video
            tabIndex={18}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("PEOPLEESTAFFINGVIDEOUNIVERSIDADE")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_people/Universidade%20Corporativa%20%281%29.mp4" />
          </video>
        </div>

        <div className="card-peoples">
          <a className="title-card-peoples" tabIndex={19}>
            Digital Lover Carreia
          </a>
          <video
            tabIndex={20}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("PEOPLEESTAFFINGVIDEOCARREIA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_people/DIGITAL%20LOVER%20CARREIA.mp4" />
          </video>
        </div>

        <div className="card-peoples">
          <a className="title-card-peoples" tabIndex={21}>
            Vídeo Tatiana
          </a>
          <video
            tabIndex={22}
            controls
            width={200}
            height={200}
            onPlay={() => pointAction("PEOPLEESTAFFINGVIDEOTATIANA")}
          >
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/ACESSIBILIDADE/PALCO%202/AREA%20EXPO/stand_people/Expo%20-%20People%20e%20Staffing%20%28Tatiana%29%283%29%20%281%29.mp4" />
          </video>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(PeoplesStaffing);
